import React from "react";
import TablaBancosAdmin from "./TablaBancosAdmin";

const ContenidoAdminBancos = () => {
    return (
        <div className="container">
            <div>
                <TablaBancosAdmin />
            </div>
        </div>
    );
};

export default ContenidoAdminBancos;
